import { jsx as _jsx } from "react/jsx-runtime";
import { EmailsItem } from "@bluframe/mightychroma-mightytool-ui";
const Add = ({ errors, isTemplate, loading, onCancel, onSave }) => (_jsx(EmailsItem, { errors: errors, isAdd: true, isSaveLoading: loading, isTemplate: isTemplate, onCancel: onCancel, onSave: onSave }));
export default Add;
